import { useEffect, useState } from "react";
import ApiService from "../../components/Api_services.jsx";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../features/authSlice.js";
const Salesman_Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pid } = useParams();
  const [loginMessage, setLoginMessage] = useState("");

  // salesmanLogin 自动登录
  useEffect(() => {
    if (pid) {
      const doSalesmanLogin = async () => {
        try {
          const data = await ApiService.login({ pid });
          if (data && data.data?.access_token) {
            // Clear everything before storing fresh data
            localStorage.clear();

            localStorage.setItem("access_token", data.data.access_token);
            // console.log("New access token set:", data.data.access_token);
            localStorage.setItem("user", data.data.user_name);
            localStorage.setItem("email", data.data.user_email);
            localStorage.setItem("main_id", data.data.main_id);
            localStorage.setItem("company_name", data.data.company_name || "");
            localStorage.setItem(
              "real_company_name",
              data.data.real_name || "",
            );
            localStorage.setItem("salesman_id", data.data.salesman_id);
            localStorage.setItem(
              "profile_photo_url",
              data.data.profile_photo_url || "",
            );
            if (data.data.sub_role) {
              localStorage.setItem(
                "sub_role",
                JSON.stringify(data.data.sub_role),
              );
            }
            localStorage.setItem(
              "is_subuser",
              data.data.is_subuser ? "true" : "false",
            );
            localStorage.setItem("subuser_id", data.data.subuser_id || "");
            localStorage.setItem("customer_id", data.data.customer_id || "");
            dispatch(
              login({
                user: {
                  name: data.data.user_name,
                  email: data.data.user_email,
                  profile_photo_url: data.data.profile_photo_url,
                  is_subuser: data.data.is_subuser || false,
                  subuser_id: data.data.subuser_id || "",
                  sub_branch: data.data.sub_branch || null,
                  main_id: data.data.main_id || null,
                  salesman_id: data.data.salesman_id || null,
                  company_name: data.data.company_name || "",
                  has_cbd: data.data.has_cbd || false,
                  has_term: data.data.has_term || false,
                  customer_id: data.data.customer_id || null,
                  real_name: data.data.real_name || "",
                },
                sub_role: data.data.sub_role || [],
              }),
            );
            window.location.replace("/"); //after login, the login page is replaced in history, so clicking back will not return to it.
          } else {
            setLoginMessage("Salesman login failed.");
          }
        } catch (err) {
          setLoginMessage("Salesman login failed.");
        }
      };
      doSalesmanLogin();
      // setTimeout(doSalesmanLogin, 3000); // Wait 3 seconds before triggering login
    }
  }, [pid, dispatch, navigate]);

  return (
    <div
      className="login-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        fontSize: "1.3rem",
        color: "#333",
        fontWeight: 500,
        letterSpacing: "0.02em",
        background: "rgba(255,255,255,0.85)",
        borderRadius: "12px",
        boxShadow: "0 2px 16px 0 rgba(0,0,0,0.07)",
        margin: "40px auto",
        padding: "2.5rem 2rem",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          marginBottom: "1.5rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          className="login-spinner"
          style={{
            width: 48,
            height: 48,
            border: "5px solid #e0e0e0",
            borderTop: "5px solid #1976d2",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: 18,
          }}
        />
        Please wait for the login process to complete...
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Salesman_Login;
